async function o({
  url: e,
  mimeType: r
}) {
  const t = await fetch(e, {
    headers: {
      Accept: r
    },
    method: "GET"
  });
  if (!t.ok)
    throw new Error(`HTTP error! status: ${String(t.status)}`);
  return t.blob();
}
export {
  o as getImageBlob
};
